import React from 'react';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import './formCard.style.scss';
import Cover from 'assets/images/backgrounds/card-cover.jpg';
import { Link } from 'react-router-dom';
import { RoutePath } from 'data';
import { __FormCardProps } from './formCard.interface';
import FormCardSkeleton from './formCard.skeleton';
import { toast } from 'react-toastify';
import { userFormDataStatus } from 'scripts/storage';
export interface FormCardProps extends __FormCardProps {}

const FormCard: React.FC<ConnectedProps<typeof connector> & __FormCardProps> = function (
    props: ConnectedProps<typeof connector> & __FormCardProps,
) {
    const lang = props.language.wsPanel.panel.forms.card;

    function onClickHandler(e) {
        if (props.expire && props.answerCount === undefined) {
            e.preventDefault();
            e.stopPropagation();
            toast.error(
                'کاربر محترم به منظور بارگزاری پاسخنامه ها لطفا یک بار از حساب کاربری خود خارج و مجددا وارد شوید',
            );
        }
    }

    return (
        <>
            {props.form ? (
                <div
                    className="ucheck-kiosk-panel-form-card"
                    onClick={() => {
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                    }}
                >
                    <Link onClick={onClickHandler} to={RoutePath.dashboard.formAnswerList(props.form.id)}>
                        {props.form.background_image_file || !props.form.background_color ? (
                            <img
                                src={props.form.background_image_file ? props.form.background_image_file.file : Cover}
                                alt="Form image"
                            />
                        ) : (
                            <span
                                style={{ backgroundColor: props.form.background_color }}
                                className="form-color-cover"
                            />
                        )}
                        <div className="details">
                            <div className="d-flex align-items-center justify-content-between">
                                <h6>{props.form.title}</h6>
                                <span className={`material-icons`}>
                                    {props.form.want_answer_notif ? 'notifications' : ''}
                                </span>
                            </div>
                            <div className="items">
                                <i className="material-icons">content_copy</i>
                                <span>{userFormDataStatus.isStored(props.form.id) ? props.answerCount : ''}</span>
                                <p>{userFormDataStatus.isStored(props.form.id) ? lang.answersCount : lang.notLoaded}</p>
                            </div>
                            <div className="items">
                                <i className="material-icons">schedule</i>
                                <p>{lang.lastActivity}</p>
                                <span>{new Date(props.form.modified_at).toLocaleDateString('fa')}</span>
                            </div>
                        </div>
                    </Link>
                </div>
            ) : (
                <FormCardSkeleton />
            )}
        </>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    userData: state.userData,
    language: state.lang,
    expire: state.expired,
});

const connector = connect(mapStateToProps);
export default connector(FormCard);
